import { Component, Injectable } from '@angular/core';
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable()
export class MatCustomPaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();

  // For internationalization, the `$localize` function from
  // the `@angular/localize` package can be used.
  firstPageLabel = `First page`;
  itemsPerPageLabel = `Items per page`;
  lastPageLabel = `Last page`;

  // You can set labels to an arbitrary string too, or dynamically compute
  // it through other third-party internationalization libraries.
  nextPageLabel = 'Next page';
  previousPageLabel = 'Previous page';
  constructor(private _translator: TranslateService) {
    this._translator.onLangChange.subscribe((event) => {
      this.translateLabels();
      this.changes.next();
    });
    this.translateLabels();
  }
  private translateLabels() {
    this.firstPageLabel = this._translator.instant('First page');
    this.itemsPerPageLabel = this._translator.instant('Items per page:');
    this.lastPageLabel = this._translator.instant('Last page');
    this.nextPageLabel = this._translator.instant('Next page');
    this.previousPageLabel = this._translator.instant('Previous page');
  }

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return `${this._translator.instant('Page')} 1 ${this._translator.instant(
        'OfP'
      )} 1`;
    }
    const amountPages = Math.ceil(length / pageSize);
    return `${this._translator.instant('Page')} ${
      page + 1
    } ${this._translator.instant('OfP')} ${amountPages}`;
  }
}
